import classNames from 'classnames/bind';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import styles from './index.module.scss';

import Bar from '@/components/ui/Bar';
import LabelGroup from '@/components/ui/LabelGroup';

const cx = classNames.bind(styles);

const Header = () => {
  const specs = useSelector((state) => state.mission.json.specs);

  const [protocol, firmware, frame] = useMemo(() => {
    const draftProtocol = 'MavLink';

    let draftFirmware = '-';
    switch (specs.firmware) {
      case 'ardupilot':
        draftFirmware = 'ArduPilot';
        break;
      case 'px4':
        draftFirmware = 'PX4';
        break;
      default:
        break;
    }

    let draftFrame = '-';
    switch (specs.frame) {
      case 'copter':
        draftFrame = 'Copter';
        break;
      case 'vtol':
        draftFrame = 'Plane (VTOL)';
        break;
      case 'rover':
        draftFrame = 'Rover';
        break;
      default:
        break;
    }

    return [draftProtocol, draftFirmware, draftFrame];
  }, [specs]);

  return (
    <div className={cx('container')}>
      <LabelGroup label="Protocol" labelFontSize={10}>
        <div className={cx('value')}>{protocol}</div>
      </LabelGroup>
      <Bar size={28} />
      <LabelGroup label="Firmware" labelFontSize={10}>
        <div className={cx('value')}>{firmware}</div>
      </LabelGroup>
      <Bar size={28} />
      <LabelGroup label="Frame" labelFontSize={10}>
        <div className={cx('value')}>{frame}</div>
      </LabelGroup>
    </div>
  );
};

export default Header;
